export default __webpack_public_path__ + "static/media/volvo.e88878ac.png";